var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex gap-2 text-primary mb-6" },
        [
          _c("v-icon", { attrs: { color: "primary", size: "20" } }, [
            _vm._v(" mdi-video-input-hdmi "),
          ]),
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v(_vm._s(_vm.$t("accountconnector.header"))),
          ]),
        ],
        1
      ),
      _c(
        "snt-loading",
        { attrs: { loading: _vm.$apollo.loading, "min-height": "285px" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-3", attrs: { flat: "" } },
            [
              _c("v-card-title", [
                _c("div", { staticClass: "text-h2-headline mb-3" }, [
                  _vm._v(" ตั้งค่าการสร้างเอกสารของระบบบัญชี "),
                ]),
              ]),
              _c(
                "v-card-text",
                [
                  _c("toggle-form", {
                    attrs: {
                      state: _vm.state["createAccountingReceipt"],
                      text: "สร้างใบเสร็จรับเงิน (Receipt)",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.submit("createAccountingReceipt")
                      },
                    },
                    model: {
                      value: _vm.form.createAccountingReceipt,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "createAccountingReceipt", $$v)
                      },
                      expression: "form.createAccountingReceipt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-tabs",
        {
          staticClass: "app-tab",
          attrs: { "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._l(_vm.tabs, function (item) {
            return _c(
              "v-tab",
              { key: `tab-${item.value}`, attrs: { href: `#${item.value}` } },
              [
                item.image
                  ? _c("v-img", {
                      staticClass: "mr-2 rounded",
                      attrs: {
                        src: item.image,
                        height: "24",
                        width: "24",
                        contain: "",
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "text-capitalize" }, [
                  _vm._v(_vm._s(item.text)),
                ]),
              ],
              1
            )
          }),
          _c("v-spacer"),
        ],
        2
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "peak", transition: "none" } },
            [_c("PeakConnect")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }